import { FC } from 'react';

import TableCell from '@mui/material/TableCell';

import { FileContentTypeIcon } from '../../../../fileContentTypeIcon/FileContentTypeIcon';

import css from './FileNameColumn.module.css';

import { ImageButton } from 'v2/components/imageButton/ImageButton';
import { FileModel } from 'v2/types/FileSystemModel';
import { fileSrc } from 'v2/utils';

interface FileNameCellProps {
  file: FileModel;
  depth: number;
}

export const FileNameColumn: FC<FileNameCellProps> = ({ file, depth }) => (
  <TableCell style={{ paddingLeft: depth * 30 }}>
    <div className={css.fileNameColumn}>
      {file.contentType.includes('image') ? (
        <ImageButton src={fileSrc(file.id)} alt={file.name} />
      ) : (
        <div className={css.fileNameIcon}>
          <FileContentTypeIcon contentType={file.contentType} />
        </div>
      )}

      <p className={css.fileName}>{file.name}</p>
    </div>
  </TableCell>
);
